import ACTION_TYPES from "../types";

// reducer.js
const INITIAL_STATE = {
  sheetListData: [],
  sheetListId: [],
  selectedSheetId: "",
  currentSelectedSheet: {},
  prevSelectedSheetId: "",
  sheetDocObj: {},
  isShared: false,
  updatedDateOfSheet: '',
  createdDateOfSheet: '',
  isCopySheetLoading: false,
  isMoveSheetLoading: false,
  isSheetDeleting: false
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_SHEET_DATA:
      return {
        ...state,
        sheetListData: action.payload,
        sheetListId: action.itemId,
        currentSelectedSheet: action.currentSelectedSheet,
        selectedSheetId: action.currentSelectedSheet?.id,
        sheetDocObj: action.sheetDocObj || state.sheetDocObj
      }
    case ACTION_TYPES.SET_SHEET_DATA:
      return {
        ...state,
        selectedSheetId: (action.selectedSheetId || action.selectedSheetId === '') ? action.selectedSheetId : state.selectedSheetId,
        sheetListData: action.sheetListData || state.sheetListData,
        //sheetListId: action.sheetListId,
        currentSelectedSheet: (action.currentSelectedSheet || action.currentSelectedSheet === '') ? action.currentSelectedSheet : state.currentSelectedSheet,
        prevSelectedSheetId: action.prevSelectedSheetId || state.prevSelectedSheetId,
        sheetDocObj: action.sheetDocObj || state.sheetDocObj,
        selectedSheetForWorkspace: action.selectedSheetForWorkspace,
        editSheetName: action.editSheetName
      }
    case ACTION_TYPES.DELETE_SHEET_ITEM:
      return {
        ...state,
        sheetListData: action.newSheetList,
        sheetListId: action.newSheetIdList,
        currentSelectedSheet: action.currentSelectedSheet
        // selectedSheetId: action.newSheetList[0]?action.newSheetList[0].id : "",
        // currentSelectedSheet: action.newSheetList[0] || null,
      }
    case ACTION_TYPES.CREATE_NEW_SHEET:
      return {
        ...state,
        sheetListData: action.payload || action.sheetListData || state.sheetListData,
        sheetListId: action.newSheetListId || state.sheetListId,
        selectedSheetId: action.selectedSheetId || state.selectedSheetId,
        currentSelectedSheet: action.currentSelectedSheet || state.currentSelectedSheet,
      }
    case ACTION_TYPES.EMPTY_SHEET_HANDLEING:
      return {
        selectedSheetId: action.selectedSheetId,
        sheetListData: action.sheetListData,
        currentSelectedSheet: action.currentSelectedSheet,
      }
    case ACTION_TYPES.GET_SHEET_ID: return { selectedSheetId: state.selectedSheetId }
    case ACTION_TYPES.SET_SHARED_SHEET:
      return {
        isShared: action.payload,
        selectedSheetId: action.selectedSheetId,
        sheetListData: action.sheetListData || state.sheetListData,
        sheetDocObj: action.sheetDocObj || state.sheetDocObj,
        currentSelectedSheet: action.currentSelectedSheet,
        sheetListId: state.sheetListId,
        updatedDateOfSheet: state.updatedDateOfSheet,
        createdDateOfSheet: state.createdDateOfSheet,
      }
    case ACTION_TYPES.SET_ISSHARED:
      return {
        ...state,
        isShared: action.isShared
      }
    case ACTION_TYPES.SET_UPDATED_DATE:
      return {
        ...state,
        updatedDateOfSheet: action.updatedDateOfSheet,
        createdDateOfSheet: action.createdDateOfSheet
      }
    case ACTION_TYPES.RESET_SHEET_STATE:
      return INITIAL_STATE;

    case ACTION_TYPES.START_COPY_SHEET:
      return {
        ...state,
        isCopySheetLoading: action.isCopySheetLoading,
        isMoveSheetLoading: action.isMoveSheetLoading,
      };
    case ACTION_TYPES.SET_IS_SHEET_DELETING:
      return {
        ...state,
        isSheetDeleting: action.isSheetDeleting,
      };
    default:
      return state;
  }
};